import React, { SVGProps } from 'react';

export default function EnterFullScreenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      {...props}>
      <path
        d="M9.14273 1.06213C9.14273 1.48153 9.44728 1.77607 9.8667 1.77607L10.5253 1.77607L13.2569 1.61795L11.089 3.6861L8.6572 6.08955C8.51739 6.22937 8.4475 6.40243 8.4475 6.59381C8.4475 7.03817 8.74204 7.36597 9.18809 7.36597C9.39441 7.36597 9.58579 7.29776 9.7239 7.14965L12.1442 4.73109L14.2072 2.55655L14.044 5.30484L14.044 5.95509C14.044 6.37112 14.3402 6.69738 14.7597 6.69738C15.1791 6.69738 15.4819 6.37451 15.4819 5.95509L15.4819 1.60471C15.4819 0.804225 15.0176 0.339844 14.2188 0.339844L9.8667 0.339844C9.45729 0.339843 9.14273 0.641008 9.14273 1.06213ZM0.518144 9.66514L0.518144 14.0155C0.518144 14.8161 0.982526 15.2803 1.78132 15.2803L6.13339 15.2803C6.5428 15.2803 6.85736 14.9793 6.85736 14.5581C6.85737 14.147 6.55281 13.8442 6.13339 13.8442L5.47484 13.8442L2.74317 14.0106L4.91108 11.9425L7.34287 9.53068C7.48268 9.39919 7.55258 9.2178 7.55258 9.02642C7.55258 8.58206 7.25804 8.25257 6.81198 8.25257C6.60568 8.25257 6.41429 8.33079 6.27449 8.47058L3.85593 10.8891L1.79286 13.0637L1.95608 10.3237L1.95608 9.66514C1.95608 9.24912 1.65984 8.93286 1.24042 8.92285C0.821008 8.92285 0.518144 9.24574 0.518144 9.66514Z"
        fill="currentColor"
      />
    </svg>
  );
}
